import { type RequestTypeEnum } from '@webapp/core/entities/internal/enums/RequestTypeEnum'
import { type Department, type Location, type User } from '@webapp/models'
import { ApiClient } from '../services/api'

export const ENDPOINT = '/api/v3/departments'
export const DEPARTMENTS_URL = ENDPOINT

export interface DepartmentsAPIGetLocationsParamsSchema {
  branch?: Location['id']
  requestable?: RequestTypeEnum
  page?: number | string
  requestable_user?: User['id']
  legal_entity?: number
}

export const DepartmentsAPI = {
  getList: (params: DepartmentsAPIGetLocationsParamsSchema) => {
    return ApiClient.get<Department[]>(`${DEPARTMENTS_URL}/`, {
      params,
    })
  },
  getDetails: (deptId, params = {}) => {
    return ApiClient.get<{}, Department>(`${DEPARTMENTS_URL}/${deptId}/`, {
      params,
    })
  },
  updateDepartmentDetails: (
    departmentId: Department['id'],
    department: Partial<Department>
  ) => {
    return ApiClient.patch(`${DEPARTMENTS_URL}/${departmentId}/`, department)
  },
}

export const getDepartmentById = (departmentId: Department['id']) =>
  ApiClient.get<Department>(`${ENDPOINT}/${departmentId}/`)
